import { render, staticRenderFns } from "./CargoVan.vue?vue&type=template&id=3b7aedb9&scoped=true&"
import script from "./CargoVan.vue?vue&type=script&lang=js&"
export * from "./CargoVan.vue?vue&type=script&lang=js&"
import style0 from "./CargoVan.vue?vue&type=style&index=0&id=3b7aedb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7aedb9",
  null
  
)

export default component.exports